"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8526],{

/***/ 48526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ArticleTagMenu": function() { return /* binding */ ArticleTagMenu; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86555);




const ArticleTagMenu = (param)=>{
    let { paths  } = param;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ArticleTagsList */ .BR, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ArticleTagMenuItem, {
                children: "All articles"
            }, "item"),
            paths.map((item)=>{
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ArticleTagMenuItem, {
                    tag: item,
                    children: item
                }, item);
            })
        ]
    });
};
const ArticleTagMenuItem = (param)=>{
    let { tag , children  } = param;
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const itemHref = {
        pathname: tag ? "/insights/tag/".concat(tag) : "/insights"
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
        href: itemHref,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ArticleTagItem */ .on, {
            isActive: (query === null || query === void 0 ? void 0 : query.tag) === tag,
            children: children
        })
    });
};


/***/ }),

/***/ 86555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ ArticleTagsList; },
/* harmony export */   "GJ": function() { return /* binding */ MetaTagLink; },
/* harmony export */   "H$": function() { return /* binding */ ArticleHeaderLinkH1; },
/* harmony export */   "H_": function() { return /* binding */ ArticleShareWrapper; },
/* harmony export */   "M3": function() { return /* binding */ ArticleSummaryReadMore; },
/* harmony export */   "O": function() { return /* binding */ ArticleShareIcon; },
/* harmony export */   "Q4": function() { return /* binding */ ArticleSummaryWrapper; },
/* harmony export */   "Qi": function() { return /* binding */ ArticleNextTitle; },
/* harmony export */   "RR": function() { return /* binding */ ArticleNextMeta; },
/* harmony export */   "X4": function() { return /* binding */ ArticleOrderedListItem; },
/* harmony export */   "XC": function() { return /* binding */ ArticleNextWrapper; },
/* harmony export */   "_6": function() { return /* binding */ ArticleSummaryContent; },
/* harmony export */   "bO": function() { return /* binding */ ArticlesListSection; },
/* harmony export */   "c3": function() { return /* binding */ ArticleHeaderLink; },
/* harmony export */   "cK": function() { return /* binding */ ArticleOrderedList; },
/* harmony export */   "hv": function() { return /* binding */ MetaName; },
/* harmony export */   "on": function() { return /* binding */ ArticleTagItem; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "yY": function() { return /* binding */ MetaDate; },
/* harmony export */   "zt": function() { return /* binding */ ArticleParagraph; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var _styles_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8066);
/* harmony import */ var _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22004);
/* harmony import */ var emotion_rgba__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49484);
/* harmony import */ var emotion_rgba__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(emotion_rgba__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44718);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 568px;\n    padding: 0;\n    margin-bottom: 7.5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 0.0625rem solid ",
        ";\n      box-sizing: border-box;\n      border-radius: 3.75rem;\n\n      &:hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-left: 2.5em;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: sticky;\n    top: 10rem;\n    margin-top: 19rem;\n    margin-bottom: 11rem;\n    max-height: 11.4rem;\n    max-width: 3rem;\n    flex-direction: column;\n    margin-left: 0;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-left: 0;\n      margin-top: 1rem;\n    "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    &:not(:last-child) {\n      margin-bottom: 3rem;\n    }\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 1rem 0 0 0;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 0 0 1rem 0;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 2rem;\n    line-height: 2.5rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 0 0 1rem 0;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 2rem;\n    line-height: 2.5rem;\n  "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    gap: 1.875rem;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 1.5rem;\n    line-height: 2rem;\n  "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}







const ArticlesListSection = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("section", {
    target: "e6co0co0"
})("display:flex;flex-direction:column;align-items:center;margin-bottom:5rem;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject())), ";");
const ContentWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co1"
})("width:100%");
const ArticleTagsList = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("ul", {
    target: "e6co0co2"
})(_styles_mixins__WEBPACK_IMPORTED_MODULE_2__/* .defaultContainerSize */ .sX, ";max-width:73rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;list-style:none;padding-top:1rem;padding-bottom:1rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-style:normal;font-weight:normal;font-size:1rem;line-height:2rem;");
const ArticleTagItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("li", {
    target: "e6co0co3"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";cursor:pointer;display:inline-block;padding:0.3125rem 1rem;white-space:nowrap;background:linear-gradient(\n    22.45deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " 3.28%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 102.02%\n  );background-clip:text;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.darker_grey;
}, ";transition:color 200ms ease-in-out;&:hover{color:", (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.darker_grey */ .C.colors.darker_grey, 0), ";}", (param)=>{
    let { isActive  } = param;
    return isActive && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1(), _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.darker_grey */ .C.colors.darker_grey, (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.darker_grey */ .C.colors.darker_grey, 1));
}, ";");
const ArticleShareWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co4"
})("display:flex;flex-direction:row;max-height:3rem;max-width:unset;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.medium((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject2())), ";", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject3())), ";");
const ArticleShareIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
    target: "e6co0co5"
})("width:3rem;height:3rem;position:relative;border:0.0625rem solid ", (param)=>{
    let { theme  } = param;
    return theme.colors.grey;
}, ";border-radius:50%;transition:box-shadow 200ms ease-in-out;svg{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}&:hover{box-shadow:0.5rem 0.5rem 1.5rem 0 #1700594a;}&:not(:first-of-type){margin-left:1rem;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject4())), ";}");
const ArticleSummaryWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co6"
})("&:not(:last-child){margin-bottom:4rem;}", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject5())), ";");
const ArticleSummaryContent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co7"
})("margin:1.5rem 0 0 0;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-weight:300;font-size:1rem;line-height:2rem;letter-spacing:0.013px;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject6())), ";");
const ArticleSummaryReadMore = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
    target: "e6co0co8"
})("position:relative;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-weight:600;font-size:1.125rem;line-height:2rem;text-decoration:none;background:linear-gradient(\n    22.45deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " 3.28%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 102.02%\n  );background-clip:text;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";transition:color 200ms ease-in-out;&:after{background:linear-gradient(\n      67.33deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " -19.99%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 98.54%\n    );transition:opacity 200ms ease-in-out;opacity:0;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__/* .pseudoElementDefaultContent */ .CR, ";}&:before{background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__/* .pseudoElementDefaultContent */ .CR, ";}&:hover{color:", (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.core_black */ .C.colors.core_black, 0), ";&:after{opacity:1;}}");
const ArticleHeaderLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
    target: "e6co0co9"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .Headline4 */ .Ou, ";margin:0 0 0.5rem 0;background:linear-gradient(\n    22.45deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " 3.28%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 102.02%\n  );background-clip:text;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";text-decoration:none;transition:color 200ms ease-in-out;display:block;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.medium((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject7())), ";", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.large((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject8())), ";&:hover{color:", (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.black */ .C.colors.black, 0), ";}&:focus{outline:none;}");
const ArticleHeaderLinkH1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("h1", {
    target: "e6co0co10"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .Headline4 */ .Ou, ";margin:0 0 0.5rem 0;background:linear-gradient(\n    22.45deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " 3.28%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 102.02%\n  );background-clip:text;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";text-decoration:none;transition:color 200ms ease-in-out;display:block;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.medium((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject9())), ";", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.large((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject10())), ";&:hover{color:", (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.black */ .C.colors.black, 0), ";}&:focus{outline:none;}");
const MetaName = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("span", {
    target: "e6co0co11"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .ParagraphS */ .fw, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-weight:400;letter-spacing:0.0125rem;");
const MetaDate = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("span", {
    target: "e6co0co12"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .ParagraphXs */ .CJ, ";font-weight:400;");
const MetaTagLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
    target: "e6co0co13"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .ParagraphXs */ .CJ, ";font-weight:400;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.darker_grey;
}, ";");
const ArticleParagraph = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("p", {
    target: "e6co0co14"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .ParagraphS */ .fw, ";margin:1.5rem 0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";");
const ArticleOrderedList = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("ol", {
    target: "e6co0co15"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0.75rem 0;padding-left:1.5rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-size:1rem;line-height:1.5rem;counter-reset:custom-counter;list-style:none outside none;position:relative;");
const ArticleOrderedListItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("li", {
    target: "e6co0co16"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0.75rem 0;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-size:1rem;line-height:1.5rem;counter-increment:custom-counter;&:before{content:counter(custom-counter) ') ';color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";font-weight:bold;position:absolute;left:0;}");
const ArticleNextWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co17"
})("display:inline-flex;flex-wrap:nowrap;gap:1rem;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.medium((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject11())), ";");
const ArticleNextMeta = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co18"
})("display:flex;flex-direction:column;justify-content:center;max-width:23.125rem;");
const ArticleNextTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
    target: "e6co0co19"
})("position:relative;font-size:1.125rem;line-height:1.5rem;font-family:var(--font-base);text-decoration:none;font-weight:normal;background:linear-gradient(\n    22.45deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " 3.28%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 102.02%\n  );background-clip:text;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";transition:color 200ms ease-in-out;cursor:pointer;&:hover{color:", (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.dark_grey */ .C.colors.dark_grey, 0), ";}", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject12())), ";");


/***/ })

}]);